import styled from "styled-components"

import { maxWidth } from "utils"

export const Container = styled.div`
  position: absolute;
  left: -4rem;
  width: calc(100vw + 2rem);

  ${maxWidth.desktop`
    width: calc(100vw + 4rem);
  `}
`

export const Item = styled.div`
  margin: 0 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: Abril;
  font-size: 1.8rem;
  font-weight: 400;
  line-height: 2.43rem;
  text-align: center;
`

export const Description = styled.p`
  margin-top: 5rem;
`

export const TopPlaceholder = styled.div`
  margin-top: 10rem;
`

export const BottomPlaceholder = styled.div`
  margin-bottom: 40rem;
`
